import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const PopularCategories = () => {
  const categories = [
    { id: 1, name: "Tax & Compliance", icon: "FileText", count: 245, color: "text-blue-600" },
    { id: 2, name: "Legal Services", icon: "Scale", count: 312, color: "text-purple-600" },
    { id: 3, name: "Business Setup", icon: "Briefcase", count: 189, color: "text-green-600" },
    { id: 4, name: "Digital Marketing", icon: "TrendingUp", count: 428, color: "text-orange-600" },
    { id: 5, name: "Financial Advisory", icon: "DollarSign", count: 356, color: "text-emerald-600" },
    { id: 6, name: "HR & Recruitment", icon: "Users", count: 267, color: "text-pink-600" },
    { id: 7, name: "IT & Software", icon: "Code", count: 534, color: "text-indigo-600" },
    { id: 8, name: "Design & Creative", icon: "Palette", count: 398, color: "text-rose-600" },
    { id: 9, name: "Consulting", icon: "Lightbulb", count: 423, color: "text-amber-600" },
    { id: 10, name: "Training & Education", icon: "GraduationCap", count: 289, color: "text-cyan-600" },
    { id: 11, name: "Real Estate", icon: "Home", count: 178, color: "text-teal-600" },
    { id: 12, name: "Insurance", icon: "Shield", count: 234, color: "text-violet-600" }
  ];

  return (
    <div className="bg-background py-12 md:py-16 lg:py-20 px-4 md:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-3 md:mb-4">
            Browse by Popular Categories
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            Explore our most sought-after service categories
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4 lg:gap-6">
          {categories?.map(category => (
            <Link
              key={category?.id}
              to={`/service-category-browse?category=${category?.id}`}
              className="group bg-card rounded-lg md:rounded-xl p-4 md:p-5 lg:p-6 shadow-sm hover:shadow-lg transition-all duration-250 border border-border"
            >
              <div className="flex flex-col items-center text-center">
                <div className={`w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 mb-3 md:mb-4 rounded-full bg-muted flex items-center justify-center ${category?.color} group-hover:scale-110 transition-transform duration-250`}>
                  <Icon name={category?.icon} size={24} className="md:w-7 md:h-7 lg:w-8 lg:h-8" />
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground mb-2 line-clamp-2">
                  {category?.name}
                </h3>
                <div className="flex items-center gap-1.5 text-xs md:text-sm text-muted-foreground">
                  <Icon name="Package" size={14} />
                  <span className="data-text">{category?.count} services</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8 md:mt-10 lg:mt-12">
          <Link
            to="/service-category-browse"
            className="inline-flex items-center gap-2 text-primary hover:gap-3 transition-all font-medium text-sm md:text-base"
          >
            <span>View All Categories</span>
            <Icon name="ArrowRight" size={20} />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PopularCategories;